module.exports = {
	APP_NAME: 'Stugo',
	API_URL: (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'http://stugo.engine/api' : 'https://admin.stugo.com/api',
	//API_URL: 'https://admin.stugo.com/api',
	DEEP_LINK_SCHEME: 'stugo',
	OWNER_EMAIL: 'getbookweb@gmail.com',
};
